import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable}     from 'rxjs/Observable';
import {Tag} from './tag';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class TagsService {

    private _tagsUrl = '/elementTagsData';    
    private serverURL: string;

    constructor(private http: Http) { 
        this.serverURL = json.api_url;
    }

    getTagsOfElement() {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + this._tagsUrl, options).toPromise().then(res => { 
                        
            if(JSON.parse(res.text()).code == 1) {
            
                return JSON.parse(res.text()).rows;

            }
        
        }, this.handleError);

    }

    getTagsThatElementHaveNot() {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + this._tagsUrl + "/addTags", options).toPromise().then(res => {

            if(JSON.parse(res.text()).code == 1) {

                return JSON.parse(res.text()).rows;

            }

        }, this.handleError);

    }

    addTags(tags: Tag[]): Promise<string> {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }
        
        return this.http.post(this.serverURL + this._tagsUrl + "/addTags", this.serializeTags(tags), {headers: authHeader}).toPromise().then(result => {
            
            return JSON.parse(result.text()).code;

        }).catch(this.handleError);

    }

    deleteTag(tag_id: number): Promise<string> {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }

        let options = new RequestOptions({ headers: authHeader, body: "" });        
        return this.http.delete(this.serverURL + this._tagsUrl + "/" + tag_id, options).toPromise().then(result => {
            
            return JSON.parse(result.text()).code;
            
        }).catch(this.handleError);

    }

    private handleError(error: any) {

        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);

    }

    private serializeObj(obj: any) {

        var result: any[] = [];        

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");

    }    

    private serializeTags(tags: Tag[]) {

        var result: any[] = [];        

        for (var i = 0; i < tags.length; i++) {

            result.push("tags[]=" + tags[i].id);

        }

        return result.join("&");

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/dashboard/tags.service.ts
 **/